import React from "react";
import { Routes, Route } from "react-router-dom";
import { PrivateRoute } from "./PrivateRoute";
import ScrollToTop from "../utils/scrollToTop";
import { routes } from "./routesConfig";
import { AdminRoute } from "./AdminRoute";

export const AppRoutes = () => {
  return (
    <>
      <ScrollToTop />
      <Routes>
        {routes.map((route) => {
          let element = <route.component />;

          if (route.private) {
            element = <PrivateRoute>{element}</PrivateRoute>;
          }

          if (route.adminOnly) {
            element = <AdminRoute>{element}</AdminRoute>;
          }

          return <Route key={route.path} path={route.path} element={element} />;
        })}
      </Routes>
    </>
  );
};